



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const CivicIssueSystem = () => {
  const navigate = useNavigate();

  const civicIssues = [
    {
      id: 1,
      title: "Road Maintenance",
      description: "Report potholes, road damage, and traffic hazards for safer commutes",
      image: "https://images.unsplash.com/photo-1542224566-6e85f2eaf2e6",
      icon: "🛣️",
      color: "from-orange-500 to-red-500"
    },
    {
      id: 2,
      title: "Public Sanitation",
      description: "Report garbage accumulation, blocked drains, and sanitation concerns",
      image: "https://images.unsplash.com/photo-1558640476-437a2e9b7a69",
      icon: "🧹",
      color: "from-green-500 to-teal-500"
    },
    {
      id: 3,
      title: "Street Lighting",
      description: "Report malfunctioning street lights and poorly lit areas for public safety",
      image: "https://images.unsplash.com/photo-1516937941344-00b4e0337589",
      icon: "💡",
      color: "from-yellow-500 to-amber-500"
    }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [likedIssues, setLikedIssues] = useState([]);

  // 🔥 NEW STATES
  const [nearbyIssues, setNearbyIssues] = useState([]);
  const [loadingNearby, setLoadingNearby] = useState(true);

  // 🔥 AUTO FETCH NEARBY ISSUES
  useEffect(() => {
    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(async (pos) => {
      const lat = pos.coords.latitude;
      const lng = pos.coords.longitude;

      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(
          `/api/user/nearby?lng=${lng}&lat=${lat}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setNearbyIssues(res.data);
      } catch (err) {
        console.log("Nearby fetch error");
      } finally {
        setLoadingNearby(false);
      }
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      handleNextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [currentSlide]);

  const handleNextSlide = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentSlide((prev) => (prev + 1) % civicIssues.length);
      setIsTransitioning(false);
    }, 500);
  };

  const handlePrevSlide = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentSlide((prev) => (prev - 1 + civicIssues.length) % civicIssues.length);
      setIsTransitioning(false);
    }, 500);
  };

  const goToSlide = (index) => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentSlide(index);
      setIsTransitioning(false);
    }, 500);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">

      {/* HERO SECTION */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          {civicIssues.map((issue, index) => (
            <div
              key={issue.id}
              className={`absolute inset-0 transition-all duration-700 ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`}
            >
              <div
                className="w-full h-full bg-cover bg-center"
                style={{ backgroundImage: `url(${issue.image})` }}
              ></div>
              <div className={`absolute inset-0 bg-gradient-to-r ${issue.color} bg-opacity-80`}></div>
            </div>
          ))}
        </div>

        <div className="relative z-10 text-center text-white max-w-6xl mx-auto px-6">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">
            Your Voice
            <span className="block text-yellow-300">Matters Here</span>
          </h1>

          <p className="text-xl mb-8">
            CivicConnect bridges the gap between citizens and local authorities
          </p>

          <button
            onClick={() => navigate('/report-issue')}
            className="px-8 py-4 bg-white text-blue-600 font-bold rounded-xl"
          >
            Report an Issue Now
          </button>
        </div>
      </section>

      {/* 🔥 NEW SECTION: NEARBY ISSUES */}
      <section className="max-w-5xl mx-auto mt-10 p-6 bg-white rounded-xl shadow">
        <h2 className="text-2xl font-bold mb-4">📍 Issues Near You</h2>

        {loadingNearby ? (
          <p>Loading nearby issues...</p>
        ) : nearbyIssues.length === 0 ? (
          <p>No issues reported nearby 🎉</p>
        ) : (
          nearbyIssues.slice(0, 5).map((issue) => (
            <div
              key={issue._id}
              className="flex justify-between items-center border-b py-3"
            >
              <div>
                <p className="font-semibold">{issue.title}</p>
                <p className="text-sm text-gray-500">
                  👍 {issue.likes} | {issue.status}
                </p>
              </div>

              {/* <button
                className="px-4 py-1 bg-blue-600 text-white rounded"
                onClick={async () => {
                  const token = localStorage.getItem("token");

                  await axios.post(
                    `/api/user/${issue._id}/like`,
                    {},
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );

                  alert("Liked!");
                }}
              >
                👍 Like
              </button> */}

              {/* <button
                disabled={likedIssues.includes(issue._id)}
                className={`px-4 py-1 rounded ${likedIssues.includes(issue._id)
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-blue-600 text-white"
                  }`}
                onClick={async () => {
                  try {
                    const token = localStorage.getItem("token");

                    await axios.post(
                      `/api/user/${issue._id}/like`,
                      {},
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      }
                    );

                    // ✅ mark as liked
                    setLikedIssues((prev) => [...prev, issue._id]);

                  } catch (err) {
                    console.log("Like error");
                  }
                }}
              >
                {likedIssues.includes(issue._id) ? "✅ Liked" : "👍 Like"}
              </button> */}

              <button
                disabled={issue.liked}
                className={`px-4 py-1 rounded ${issue.liked
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-600 text-white"
                  }`}
                onClick={async () => {
                  try {
                    const token = localStorage.getItem("token");

                    const res = await axios.post(
                      `/api/user/${issue._id}/like`,
                      {},
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      }
                    );

                    // ✅ UPDATE UI INSTANTLY
                    setNearbyIssues((prev) =>
                      prev.map((i) =>
                        i._id === issue._id
                          ? {
                            ...i,
                            likes: res.data.likes,
                            liked: true
                          }
                          : i
                      )
                    );

                  } catch (err) {
                    console.log(err.response?.data?.message || "Like error");
                  }
                }}
              >
                {issue.liked ? "✅ Liked" : "👍 Like"}
              </button>
            </div>
          ))
        )}

        <div className="text-center mt-4">
          <button
            className="px-5 py-2 bg-green-600 text-white rounded"
            onClick={() => navigate("/map")}
          >
            View on Map 🗺️
          </button>
        </div>
      </section>

    </div>
  );
};

export default CivicIssueSystem;